import { faColumns3 } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ClickAwayListener, FormControlLabel, Paper, Popper, Stack, Switch, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import { useContractsContext } from './ContractsContext';

function ContractColumnFilter() {
  const { columnHeadings: columns, hiddenColumns, setHiddenColumns } = useContractsContext();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const togglePopper = (e) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(e.target);
    }
  };

  const toggleHiddenColumn = (index) => {
    let newValue;
    if (hiddenColumns.includes(index)) {
      newValue = hiddenColumns.filter((value) => value !== index);
    } else {
      newValue = [...hiddenColumns, index];
    }
    setHiddenColumns(newValue);
  };

  const hideAll = () => {
    const newValue = Array.from({ length: columns.length - 1 }, (_, i) => i + 1);
    setHiddenColumns(newValue);
  };

  const showAll = () => {
    const newValue = [];
    setHiddenColumns(newValue);
  };

  return (
    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
      <div>
        <Tooltip title="Filter Columns">
          <Button
            size="small"
            variant="text"
            onClick={(e) => togglePopper(e)}
            color="primary"
            sx={{ minWidth: 'auto' }}
          >
            <FontAwesomeIcon icon={faColumns3} />
          </Button>
        </Tooltip>
        <Popper anchorEl={anchorEl} open={Boolean(anchorEl)} placement="bottom-start">
          <Paper sx={{ py: 1, px: 2, mt: 1 }}>
            <Stack sx={{ width: '100%' }}>
              {columns.map((columnName, index) => (
                <Stack key={columnName} direction="row" alignItems="center">
                  <FormControlLabel
                    label={columnName}
                    control={
                      <Switch
                        disabled={index === 0}
                        onClick={() => toggleHiddenColumn(index)}
                        size="small"
                        checked={!hiddenColumns.includes(index)}
                      />
                    }
                  />
                </Stack>
              ))}
              <Stack direction="row" justifyContent="space-between">
                <Button variant="text" size="small" onClick={hideAll}>
                  Hide All
                </Button>
                <Button variant="text" size="small" onClick={showAll}>
                  Show All
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
}

export default ContractColumnFilter;
